import * as constActions from './AlertsConstActions';
import alertsApi from '../api/alertsApi';
import ProcessTree from '../../../common/Models/ProcessTree';

//Thunk update Alert status on Server
export function updateAlertStatus(alert, remove) {
  return function (dispatch, getState) {
    return alertsApi
      .updateAlertStatus({ alerts: [{ id: alert.id }], toStatus: alert.status })
      .then(result => {
        if (remove) {
          dispatch(updateRemoveAlertStatusSuccess(alert));
        }
        dispatch(updateAlertStatusSuccess(alert));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function updateAlertStatusSuccess(alert) {
  return { type: constActions.POST_ALERT_NEW_STATUS_SUCCESS, alert };
}
export function updateRemoveAlertStatusSuccess(alert) {
  return { type: constActions.POST_ALERT_REMOVE_NEW_STATUS_SUCCESS, alert };
}
//Thunk update alerts Array status on Server without reducer
export function updateStatusForAlertsArr(alertsAndNewStatus) {
  return function (dispatch, getState) {
    return alertsApi.updateAlertStatus(alertsAndNewStatus);
  };
}
export function updateAllAlertsStatus(newStatus) {
  return function (dispatch, getState) {
    return alertsApi.updateAllAlertsStatus(newStatus);
  };
}
export function countOpenAlerts() {
  return function (dispatch, getState) {
    return alertsApi.countOpenAlerts();
  };
}

export function getAlertsCountByEntity() {
  return function (dispatch) {
    return alertsApi
      .getAlertsCountByEntity()
      .then(alertsCountByEntity => {
        dispatch(getAlertsCountByEntitySuccess(alertsCountByEntity));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function getAlertsCountByEntitySuccess(alertsCountByEntity) {
  return { type: constActions.GET_ALERTS_COUNT_BY_ENTITY, alertsCountByEntity };
}

export function getAlertCountByDate() {
  return function (dispatch) {
    return alertsApi
      .getAlertCountByDate()
      .then(alertsCountByDate => {
        dispatch(getAlertCountByDateSuccess(alertsCountByDate));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function getAlertCountByDateSuccess(alertsCountByDate) {
  return { type: constActions.GET_ALERTS_COUNT_BY_DATE, alertsCountByDate };
}

//Thunk search Alerts by criterias (Action Creator)
export function searchAlerts(criterias, clearExisting = false) {
  return function (dispatch, getState) {
    return alertsApi
      .getSearchAllOverallAlerts(criterias)
      .then(alerts => {
        if (!clearExisting) {
          dispatch(searchAlertsbyCriterias(alerts, alerts.alerts.length));
        } else {
          dispatch(searchAlertsbyCriteriasAndClearExisting(alerts, alerts.alerts.length));
        }
      })
      .catch(error => {
        throw error;
      });
  };
}
export function searchAlertsbyCriterias(alerts, amount) {
  return { type: constActions.POST_SEARCH_ALERTS_SUCCESS, alerts, amount };
}
export function searchAlertsbyCriteriasAndClearExisting(alerts, amount) {
  return { type: constActions.POST_SEARCH_NEW_ALERTS_SUCCESS, alerts, amount };
}

export function getComments(alertId) {
  return function (dispatch) {
    return alertsApi
      .getComments(alertId)
      .then(comments => {
        dispatch(getCommentsSuccess(comments, alertId));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function getCommentsSuccess(comments, alertId) {
  return { type: constActions.GET_COMMENTS_SUCCESS, comments, alertId };
}

export function addComment(comment) {
  return function (dispatch) {
    return alertsApi
      .addComment(comment)
      .then(result => {
        dispatch(addCommentSuccess(result));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function addCommentSuccess(comment) {
  // UPDATE LIST
  return { type: constActions.ADD_COMMENT_SUCCESS, comment };
}

export function addComments(comments) {
  return function (dispatch, getState) {
    return alertsApi
      .addComments(comments)
      .then(comments => {
        if (comments.length != null) {
          comments.forEach(function (element) {
            dispatch(addCommentSuccess(element));
          }, this);
        }
      })
      .catch(error => {
        throw error;
      });
  };
}

export function addCommentsSuccess(alertsrowsdata) {
  return { type: constActions.ADD_COMMENTS_SUCCESS, alertsrowsdata };
}

export function exportToExcel(criterias) {
  return function (dispatch) {
    return alertsApi.exportToExcel(criterias).catch(error => {
      throw error;
    });
  };
}

export function getAlertById(alertId, isBottomPanelShown) {
  return function (dispatch) {
    return alertsApi
      .getAlertById(alertId)
      .then(result => {
        if (result.success != false) {
          let alert = Object.assign({}, result, {
            isBottomPanelShown: isBottomPanelShown,
            incidentId: result.IncidentId
          });
          dispatch(getAlertByIdSuccess(alert));
        }
      })
      .catch(error => {
        throw error;
      });
  };
}

export function getAlertByIdSuccess(alert) {
  return { type: constActions.GET_ALERT_BY_ID_SUCCESS, alert };
}

export function onSelectAlertRows(alertRows) {
  return function (dispatch, getState) {
    let state = getState().overallalerts;
    let selectedAlertRows = [...state.selectedAlertRows, ...alertRows];
    dispatch({
      type: constActions.UPDATE_SELECTED_ALERT_ROWS,
      selectedAlertRows
    });
  };
}

export function onSelectAllAlertRows(allAlertRows) {
  return function (dispatch, getState) {
    let selectedAlertRows = allAlertRows;
    dispatch({
      type: constActions.UPDATE_SELECTED_ALERT_ROWS,
      selectedAlertRows
    });
  };
}

export function onDisSelectAlertRow(alertRow) {
  return function (dispatch, getState) {
    let state = getState().overallalerts;
    let selectedAlertRows = state.selectedAlertRows.filter(curVal => alertRow.id !== curVal.id);
    dispatch({
      type: constActions.UPDATE_SELECTED_ALERT_ROWS,
      selectedAlertRows
    });
  };
}

export function onDisSelectAllAlertRow(alertRow) {
  return function (dispatch, getState) {
    let selectedAlertRows = [];
    dispatch({
      type: constActions.UPDATE_SELECTED_ALERT_ROWS,
      selectedAlertRows
    });
  };
}

export function dispatchAlertRowValue(rowData, fieldName, fieldValue) {
  return function (dispatch, getState) {
    let state = getState().overallalerts;
    let alert = Object.assign({}, rowData, {
      [fieldName]: fieldValue
    });

    let alertsrowsdata = state.alertsrowsdata.map((currAlert, index) => {
      if (currAlert.id == alert.id) {
        return alert;
      }
      return currAlert;
    });

    dispatch({ type: constActions.UPDATE_ALERT_ROWS, alertsrowsdata });
  };
}

export function dispatchIsBottomPanelShow(rowData, fieldValue) {
  return function (dispatch, getState) {
    let state = getState().overallalerts;
    let alert = Object.assign({}, rowData, {
      isBottomPanelShown: fieldValue
    });

    let alertsrowsdata = state.alertsrowsdata.map((currAlert, index) => {
      if (currAlert.id == alert.id) {
        return Object.assign({}, rowData, {
          isBottomPanelShown: fieldValue
        });
      } else {
        return Object.assign({}, currAlert, {
          isBottomPanelShown: false
        });
      }
    });

    dispatch({ type: constActions.UPDATE_ALERT_ROWS, alertsrowsdata });
  };
}

export const setSeverityAll = () => ({
  type: constActions.SET_SEVERITY_ALL
});

export const setSeverityFilterHighCritical = () => ({
  type: constActions.SET_SEVERITY_HIGH_CRITICAL
});

export const setSeverity = severity => ({
  type: constActions.SET_SEVERITY,
  severity
});

export function getAlertProcessTreeRequest() {
  return { type: constActions.GET_ALERT_PROCESS_TREE_REQUEST };
}

export function getAlertProcessTreeSuccess(alertProcessTree, alertId) {
  return {
    type: constActions.GET_ALERT_PROCESS_TREE_SUCCESS,
    alertProcessTree,
    alertId
  };
}

export function getAlertProcessTree(alertId) {
  return function (dispatch) {
    dispatch(getAlertProcessTreeRequest());
    return alertsApi
      .getAlertProcessTree(alertId)
      .then(processTreeResponse => {
        let processTree = ProcessTree.parse(processTreeResponse);
        dispatch(getAlertProcessTreeSuccess(processTree, alertId));
      })
      .catch(error => {
        throw error;
      });
  };
}

//Only global actions
//TODO:: need to remove all those duplicate function inside the app
export function getSitesPerUser() {
  return async function (dispatch) {
    try {
      const result = await alertsApi.GetAllSitesGlobal();
      if (result != null) {
        const arr = result.map(element => ({ label: element.Name, value: element.ClientId, selected: true }));
        dispatch(getSitesPerUserSuccess(arr));
      }
      return result;
    } catch (error) {
      throw error;
    }
  };
}
export function getSitesPerUserSuccess(data) {
  return { type: constActions.SET_SITES_PER_USER, data };
}

export function clearAlertRows() {
  return function (dispatch) {
    dispatch({ type: constActions.UPDATE_ALERT_ROWS, alertsrowsdata: [] });
  };
}
